module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5vUwr"))).then(() => parcelRequire('1iHdE'));